const FEATURE_HELP_URLS = {
  agent_bots: 'https://app.vowchat.ai/hc/',
  agents: 'https://app.vowchat.ai/hc/',
  audit_logs: 'https://app.vowchat.ai/hc/',
  campaigns: 'https://app.vowchat.ai/hc/',
  canned_responses: 'https://app.vowchat.ai/hc/',
  channel_email: 'https://app.vowchat.ai/hc/',
  channel_facebook: 'https://app.vowchat.ai/hc/',
  custom_attributes: 'https://app.vowchat.ai/hc/',
  dashboard_apps: 'https://app.vowchat.ai/hc/',
  help_center: 'https://app.vowchat.ai/hc/',
  inboxes: 'https://app.vowchat.ai/hc/',
  integrations: 'https://app.vowchat.ai/hc/',
  labels: 'https://app.vowchat.ai/hc/',
  macros: 'https://app.vowchat.ai/hc/',
  message_reply_to: 'https://app.vowchat.ai/hc/',
  reports: 'https://app.vowchat.ai/hc/',
  sla: 'https://app.vowchat.ai/hc/',
  team_management: 'https://app.vowchat.ai/hc/',
  webhook: 'https://app.vowchat.ai/hc/',
  billing: 'https://app.vowchat.ai/hc/',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
